import { gql } from "@apollo/client";
import { GraphQLQuery } from "@aws-amplify/api";
import { GetUploadLogoUrlQuery } from "API";
import { client } from "graphql/client";
import { getUploadLogoUrl } from "graphql/queries";

export const uploadImage = async (
  imageDataURL: string,
  logoImageId: string
): Promise<void> => {
  const fileBlob = await fetch(imageDataURL).then((res) => res.blob());
  const input = { filename: logoImageId };
  const { data } = await client.query<GraphQLQuery<GetUploadLogoUrlQuery>>({
    query: gql(getUploadLogoUrl),
    variables: { input },
  });

  if (data?.getUploadLogoUrl?.url) {
    await fetch(data.getUploadLogoUrl.url, {
      method: "PUT",
      headers: { "Content-Type": fileBlob.type },
      body: fileBlob,
    });
  }
};
